export class SlackFileNotFoundError extends Error {}
